<template>
<div>
    <validation-observer >
        <b-form @submit.prevent="SimpanMaklumat" style="width:1000px;">
            <h3 class="mb-0">MAKLUMAT PERGERAKAN GAJI (BIASA)</h3>
            <br />
            <div class="pl-lg-2">
                <validation-provider name="Amaun Dalam Buku Servis" :rules="{ required: true }" >
                    <b-row>
                        <b-col sm="3"> Amaun Dalam Buku Servis </b-col>
                        <b-col sm="1"> :</b-col>
                        <b-col sm="6">
                            <b-form-input id="AmaunTelahTerima" v-model="Obj.AmaunTelahTerima" ></b-form-input>
                        </b-col>
                    </b-row>
                </validation-provider>
                <br />
                <validation-provider name="Status PGT " :rules="{ required: true }" >
                    <b-row class="my-1">
                        <b-col sm="3">PGT diawalkan (Bagi Tujuan Kenaikan Pangkat, Meninggal Dunia, Bersara Wajib sebelum Tarikh Pergerakan Gaji dan Urusan Pertukaran Perlantikan yang merubah TPG)</b-col>
                        <b-col sm="1"> :</b-col>
                        <b-col sm="6">
                            <b-form-group v-slot="{ ariaDescribedby }">
                                <b-form-radio v-model="Obj.StatusPGT" :aria-describedby="ariaDescribedby" name="some-radios" value="1">TIDAK</b-form-radio>
                                <b-form-radio v-model="Obj.StatusPGT" :aria-describedby="ariaDescribedby" name="some-radios" value="2">YA</b-form-radio>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </validation-provider>
                <br/>
                <div v-if="Obj.StatusPGT==2">
                <validation-provider name="Tarikh Kuatkuasa" :rules="{ required: true }" >
                        <b-row class="my-1">
                            <b-col lg='3'>Tarikh Kuatkuasa</b-col>
                            <b-col lg='1'>:</b-col>
                            <b-col lg='4'>
                               <base-input type="date" v-model="Obj.EftDate" />
                            </b-col>
                        </b-row>
                    </validation-provider>
                    <br/>
                </div>
                <validation-provider name="Catatan" :rules="{ required: true }" >
                    <b-row>
                        <b-col sm="3"> Catatan </b-col>
                        <b-col sm="1"> :</b-col>
                        <b-col sm="8">
                            <!-- <b-form-input v-model="Obj.Catatan" :state="getValidation(validationContext)" class="custom-input"></b-form-input> -->
                            <b-form-textarea v-model="Obj.Catatan" class="custom-input" rows="4" maxlength="1000" placeholder="Masukkan catatan (maksimum 1000 aksara)"></b-form-textarea>
                        </b-col>
                    </b-row>
                </validation-provider>
                <b-form-row>
                    <b-col>
                        <b-form-group>
                            <div>
                                <b-col>&nbsp;</b-col>
                                <b-col align="center">
                                    <b-button variant="success" type="submit">SIMPAN</b-button>
                                    <!-- <b-button size="md" variant="primary" v-show="active" @click="next()">KEMBALI</b-button>
                                                <b-button size="md" variant="primary" v-show="active" @click="next()">SETERUSNYA</b-button> -->
                                    <!-- <b-button size="md" variant="primary" v-show="active" @click="nextPapar()">PAGE PAPAR</b-button> -->

                                </b-col>
                            </div>
                        </b-form-group>
                    </b-col>
                </b-form-row>
            </div>
        </b-form>
    </validation-observer>
</div>
</template>

<script>
import moment from "moment";
import Store from "@/store";
import GetselenggaraService from "@/services/selenggaraService.js";
import GetsalaryService from "@/services/salaryService.js";
import swal from "sweetalert2";
export default {
    props: ["tahun"],
    data() {
        return {
            Obj: {
                StatusPGT:1,
                AmaunTelahTerima:0.00,
                Catatan: "Pergerakan Gaji Tahunan secara Biasa"
            },
            StatusSimpan: {},
        };
    },
    methods: {
        getValidation({
            dirty,
            validated,
            valid = null
        }) {
            return dirty || validated ? valid : null;
        },
        SimpanMaklumat() {
            this.Obj.coid = Store.state.MaklumatPeribadi.coid;
            this.Obj.tahun = this.tahun;
            console.log("logasda", this.Obj);
            (this.Obj.elemenId = 2),

            GetsalaryService.setElemenPGT(this.Obj).then((resp) => {
                this.StatusSimpan = resp.data;
            }).then(() => {

                console.log("StatusSimpan", this.StatusSimpan);

                if (this.StatusSimpan.Status == 1) {
                    swal
                        .fire({
                            title: "BERJAYA DI SIMPAN!",
                            text: "KLIK OK UNTUK TERUSKAN.",
                            icon: "success",
                        })
                        .then(() => {
                            this.$emit("batal");
                        });
                } else {
                    swal.fire({
                        title: this.StatusSimpan.details,
                        text: "KLIK OK UNTUK TERUSKAN.",
                        icon: "error",
                    }).then(() => {
                        this.$emit("batal");
                    });
                }
            });
        }
    },
    computed: {
        coid() {
            return Store.state.MaklumatPeribadi[0].coid;
        }
    },
    created() {
        // this.Obj = Store.state.MaklumatPeribadi;

    }
};
</script>
<style scoped>


.custom-input-large {
  font-size: 1.25rem; /* Atur ukuran font lebih besar */
  padding: .75rem 1.5rem; /* Sesuaikan padding input */
  height: auto; /* Sesuaikan tinggi input */
}
</style>